module.exports = __webpack_public_path__ + "static/outofbox1-e2c30e196f1e3585c5fb3c144f20b6f4.png";